<template>
    <div class="l-goal-stat-list-item tw-grid tw-grid-cols-12 tw-mt-2 tw-mb-2">
        <div
            v-if="goal.type === 'goalUser'"
            class="tw-items-center tw-flex tw-space-x-6"
            :class="{ 'tw-col-span-6': !expandStats, 'tw-col-span-4': expandStats }"
        >
            <l-profile-picture :user="goal.user" size="xm" />

            <span>
                <strong>{{ goal.user.fullname }}</strong>
                <br />
                <span class="color-primary">
                    <span
                        class="clickable"
                        tabindex="0"
                        @click="
                            showGoalsList({
                                segment: 'all',
                                filters: [
                                    {
                                        value: goal.user._id,
                                        type: 'users',
                                    },
                                ],
                            })
                        "
                        @keyup.enter="
                            showGoalsList({
                                segment: 'all',
                                filters: [
                                    {
                                        value: goal.user._id,
                                        type: 'users',
                                    },
                                ],
                            })
                        "
                    >
                        {{
                            $t("goals.list.labelShowGoals", {
                                c: goal.count,
                            })
                        }}
                    </span>
                </span>
            </span>
        </div>
        <div
            v-else-if="goal.type === 'goalLocalTeam'"
            class="tw-items-center tw-flex tw-space-x-6"
            :class="{ 'tw-col-span-6': !expandStats, 'tw-col-span-4': expandStats }"
        >
            <l-profile-picture :user="{ name: goal.localTeam.name }" size="xm" />

            <span>
                <strong>{{ goal.localTeam.name }}</strong>
                <br />
                <span class="color-primary">
                    <span
                        class="clickable"
                        tabindex="0"
                        @click="
                            showGoalsList({
                                segment: 'all',
                                filters: [
                                    {
                                        value: goal.localTeam._id,
                                        type: 'localTeams',
                                    },
                                ],
                            })
                        "
                        @keyup.enter="
                            showGoalsList({
                                segment: 'all',
                                filters: [
                                    {
                                        value: goal.localTeam._id,
                                        type: 'localTeams',
                                    },
                                ],
                            })
                        "
                    >
                        {{
                            $t("goals.list.labelShowGoals", {
                                c: goal.count,
                            })
                        }}
                    </span>
                </span>
            </span>
        </div>
        <div
            v-else-if="goal.type === 'goalTeam'"
            class="tw-items-center tw-flex tw-space-x-6"
            :class="{ 'tw-col-span-6': !expandStats, 'tw-col-span-4': expandStats }"
        >
            <div>
                <l-profile-picture :user="{ name: 'C' }" size="xm" />
            </div>
            <span class="l-default-margin">
                <strong>All company goals</strong>
                <br />
                <span class="color-primary">
                    <span
                        class="clickable"
                        tabindex="0"
                        @click="showGoalsList({ segment: 'all' })"
                        @keyup.enter="showGoalsList({ segment: 'all' })"
                    >
                        {{
                            $t("goals.list.labelShowGoals", {
                                c: goal.count,
                            })
                        }}
                    </span>
                </span>
            </span>
        </div>
        <div v-else class="tw-col-span-6 tw-items-center tw-flex tw-space-x-6">
            <span class="color-dark tw-font-bold tw-mt-2">
                {{ titleAllGoals }}
            </span>
        </div>

        <div
            class="tw-items-center tw-flex tw-space-x-6"
            :class="{ 'tw-col-span-6': expandStats, 'tw-col-span-4': !expandStats }"
        >
            <div>
                <span
                    v-b-popover.hover.top="{
                        content: `${$t(`goals.list.helpActiveOffTrack`)} / ${$t(
                            `goals.list.helpCanceled`,
                        )}`,
                    }"
                    class="label label-danger tw-mr-2"
                >
                    <i class="fal fa-times tw-mr-2"></i> {{ goal.offTrack + goal.canceled }}
                </span>

                <span
                    v-b-popover.hover.top="{
                        content: `${$t(`goals.list.helpActiveInputNeeded`)}`,
                    }"
                    class="label label-warning tw-mr-2"
                >
                    <i class="fal fa-exclamation-triangle tw-mr-2"></i> {{ goal.inputNeeded }}
                </span>

                <span
                    v-b-popover.hover.top="{
                        content: `${$t(`goals.list.helpDone`)} / ${$t(
                            `goals.list.helpActiveOnTrack`,
                        )}`,
                    }"
                    class="label label-success tw-mr-2"
                >
                    <i class="fal fa-flag tw-mr-2"></i> {{ goal.onTrack + goal.done }}
                </span>

                <span
                    v-b-popover.hover.top="{
                        content: `${$t(`goals.list.labelGoalUpdatesCount`)}`,
                    }"
                    class="label label-success tw-mr-2"
                >
                    <i class="fal fa-check tw-mr-2"></i> {{ goal.updatesCount || 0 }}
                </span>

                <span
                    v-b-popover.hover.top="{
                        content: `${$t(`goals.list.labelGoalNoUpdates`)}`,
                    }"
                    class="label label-success tw-mr-2"
                >
                    <i class="fal fa-snooze tw-mr-2"></i> {{ goal.notUpdatedGoalCount || 0 }}
                </span>
            </div>
        </div>

        <div class="tw-col-span-2 tw-pb-4">
            <div class="tw-mt-5">
                <l-progress :progress-percent="goal.progress" />
            </div>
        </div>
    </div>
</template>

<script>
import LProfilePicture from "@/components/LProfilePicture";
import LProgress from "@/components/LProgress";
export default {
    components: {
        LProfilePicture,
        LProgress,
    },
    props: {
        goal: {
            type: Object,
            required: true,
        },
        titleAllGoals: {
            type: String,
            default: "",
        },
        expandStats: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {};
    },
    methods: {
        showGoalsList(opts) {
            this.$emit("click", opts);
        },
    },
};
</script>
